/**
 * Per-canvas link panel persistence (browser localStorage only).
 * Keyed by design pageId so A / B / C never overwrite each other.
 */

const STORAGE_VERSION = 'v1'
const KEY_PREFIX = `prjconcurrent-editor-${STORAGE_VERSION}`

export function editorStorageKey (pageId) {
  return `${KEY_PREFIX}:${pageId}`
}

export function loadLinkPanelsFromLocal (pageId) {
  if (typeof localStorage === 'undefined' || !pageId) return []
  try {
    const raw = localStorage.getItem(editorStorageKey(pageId))
    if (!raw) return []
    const data = JSON.parse(raw)
    if (data && Array.isArray(data.linkPanels)) return data.linkPanels
  } catch (_) {}
  return []
}

export function saveLinkPanelsToLocal (pageId, linkPanels) {
  if (typeof localStorage === 'undefined' || !pageId) return
  try {
    localStorage.setItem(editorStorageKey(pageId), JSON.stringify({ linkPanels }))
  } catch (e) {
    console.warn('editor localStorage save failed:', e)
  }
}

export function clearLinkPanelsLocal (pageId) {
  if (typeof localStorage === 'undefined' || !pageId) return
  try {
    localStorage.removeItem(editorStorageKey(pageId))
  } catch (_) {}
}
